module.exports = __webpack_public_path__ + "img/imgPlaceholder.7391e818.svg";